module.exports = __webpack_public_path__ + "img/main_btn03.666c1706.jpg";